<template>
  <footer :class="classList">
    <slot>
      <div>
        <a >CRM</a>
        <span>&copy; 2020 </span>
      </div>
      <div class="ml-auto">
        <span>Powered by</span>
        <a >Tarvel Technology Limited</a>
      </div>
    </slot>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  props: {
    fixed: {
      type: Boolean,
      default: false
    }
  },
  mounted: function () {
    this.isFixed()
  },
  computed: {
    classList () {
      return [
        'app-footer'
      ]
    }
  },
  methods: {
    isFixed () {
      this.fixed ? document.body.classList.add('footer-fixed') : document.body.classList.remove('footer-fixed')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Footer/Footer.vue